export default __webpack_public_path__ + "static/media/dulcolax.7a674317.jpg";